export const colors = [
  "bg-purplePleasures",
  "bg-magentarama",
  "bg-mediumVermilion",
  "bg-yakitori",
  "bg-earlySpring",
  "bg-wavelet"
];
export const roundsOfEffect = 10;
